import { createAction, props } from '@ngrx/store';

export const widgetToggleAutoPublish = createAction('[Widget] toggle auto publish', props<{ autoPublish: boolean }>());
export const widgetUpdate = createAction('[Widget] update', props<{ payload: any }>());
export const widgetSaveSettings = createAction('[Widget] save settings');
export const widgetSkip = createAction('[Widget] skip');
